module.exports = __webpack_public_path__ + "img/product_img1.7d8d989f.png";